export const environment = {
  production: true,
  isPROD: false,
  isStage: true,
  isDev: false,
  isQA: false,
  apiKeyPAASEnabled: true,
  superAdmin: 'https://super-admin-api.uat-truckstop.zuumapp.com/v1',
  superAdminApiKey: 'AIzaSyCmCF-mRDS53ODe7exTGPzBNUiIA61PGJM',
  baseUrl: 'https://ship-api.uat-truckstop.zuumapp.com',
  esApiUrl: 'https://es.uat-truckstop.zuumapp.com/v1',
  esSocketApiUrl: 'https://es.uat-truckstop.zuumapp.com',
  storageApiUrl: 'https://storage.uat-truckstop.zuumapp.com/v1',
  trackingApiUrl: 'https://tracking-api.uat-truckstop.zuumapp.com/v1',
  reportingUrl: 'https://reporting-api.uat-truckstop.zuumapp.com',
  ratingUrl: 'https://rating-api.uat-truckstop.zuumapp.com/v1',
  tasksUrl: 'https://task-api.uat-truckstop.zuumapp.com/v1',
  pricingUrl: 'https://pricing-api.uat-truckstop.zuumapp.com/graphql',
  carbonFootprintUrl: 'https://carbon-footprint.uat-truckstop.zuumapp.com',
  brokerWebLink: 'https://admin.uat-truckstop.zuumapp.com',
  carrierWebLink: 'https://carrier.uat-truckstop.zuumapp.com',
  shipperWebLink: 'https://ship.uat-truckstop.zuumapp.com',
  contractAiApiUrl: 'https://contractai-api.uat-truckstop.zuumapp.com/api',
  mapsApiUrl: 'https://maps.uat-truckstop.zuumapp.com/api/v1',
};
